export default {
  data() {
    return {
      opened: false,
    }
  },
  computed: {
    closed() {
      return !this.opened
    },
  },
  mounted() {
    this.getTransactionsSettings()
  },
  methods: {
    getTransactionsSettings() {
      this.$http.get('company-account/transactions-opened-settings').then(res => {
        this.opened = !!res.data
      })
    },
    closeTransactions() {
      this.tableLoading = true
      this.$http.put('company-account/transactions/', { transactions_opened: this.opened })
        .then(res => {
          this.showSuccess('Transactions closed successfully')
        })
        .catch(err => {
          if (err.response.status === 403) {
            this.showInfo('You must be an admin to open or close transactions')
          } else {
            this.showError(`Failed to ${this.closed ? 'open' : 'close'} transactions`)
          }
          this.closed = !this.closed
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
  },
}
